import { newSpecPage } from '@stencil/core/testing'
import { CobaltRadioButton } from '../cobalt-radio-button'

describe('core-radio-button', () => {
  it('should render radio button element unchecked', async () => {
    const page = await newSpecPage({
      components: [CobaltRadioButton],
      html: '<cobalt-radio-button></core-radio-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-radio-button>
        <core-radio-button format="right"></core-radio-button>
      </core-radio-button>
    `)
  })
  it('should render radio button element checked', async () => {
    const page = await newSpecPage({
      components: [CobaltRadioButton],
      html: '<cobalt-radio-button checked></core-radio-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-radio-button checked="">
        <core-radio-button checked="" format="right"></core-radio-button>
      </core-radio-button>
    `)
  })
  it('should change format to left', async () => {
    const page = await newSpecPage({
      components: [CobaltRadioButton],
      html: '<cobalt-radio-button format="left"></core-radio-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-radio-button format="left">
        <core-radio-button format="left"></core-radio-button>
      </core-radio-button>
    `)
  })
  it('should change format to hidden', async () => {
    const page = await newSpecPage({
      components: [CobaltRadioButton],
      html: '<cobalt-radio-button format="hidden"></core-radio-button>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-radio-button format="hidden">
        <core-radio-button format="hidden"></core-radio-button>
      </core-radio-button>
    `)
  })
})
